import { useCallback, useState } from 'react'
import { getSucursalByDomain } from '@utils/api/api.sucursales'
import type { GetSucursalByDomainResponse } from '@contracts/api/sucursales'

export const useSucursales = () => {
    const [loading, setLoading] = useState(false)

    const getSucursalDomainHook = useCallback(
        async (domain: string): Promise<GetSucursalByDomainResponse> => {
            setLoading(true)
            try {
                return await getSucursalByDomain({ domain })
            } finally {
                setLoading(false)
            }
        },
        []
    )

    return {
        loading,
        getSucursalDomainHook,
    }
}
